export const CheckedSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3848 22C17.9076 22 22.3848 17.5228 22.3848 12C22.3848 6.47715 17.9076 2 12.3848 2C6.86192 2 2.38477 6.47715 2.38477 12C2.38477 17.5228 6.86192 22 12.3848 22Z"
        fill="white"
      />
      <path
        d="M8.38477 12.5L11.3848 15.5L16.3848 9.5"
        stroke={props.stroke || '#3E4685'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
